<!-- YÜKLEME: Kart okundu, personel sorgulanıyor -->
<div class="aktif-icerik aktif-enter">
  <div class="kart-yukleniyor">
    <div class="ky-pulse-ring">
      <div class="ky-ring r1"></div>
      <div class="ky-ring r2"></div>
      <div class="ky-ring r3"></div>
    </div>
    <div class="ky-ikon">💳</div>
    <div class="ky-yazi">Kart Okunuyor...</div>
    <div class="ky-alt">Personel bilgileri getiriliyor</div>
  </div>
</div>
